export default __webpack_public_path__ + "static/media/video.576d4652.svg";